(() => {
  'use strict';

  const BADGE_SELECTOR = '[data-quick-add-cart-count][data-product-id]';
  let productQuantities = new Map();
  let refreshVersion = 0;
  let renderQueued = false;

  function renderBadges() {
    document.querySelectorAll(BADGE_SELECTOR).forEach((badge) => {
      const productId = String(badge.dataset.productId || '');
      const quantity = productQuantities.get(productId) || 0;
      const visible = quantity > 0;
      const displayQuantity = quantity > 99 ? '99+' : String(quantity);

      if (badge.textContent !== displayQuantity) badge.textContent = displayQuantity;
      if (badge.hidden !== !visible) badge.hidden = !visible;
      badge.dataset.inCartQuantity = String(quantity);
      badge.title = visible ? `${quantity} in cart` : '';

      const button = badge.closest('button');
      if (button) {
        button.dataset.inCartQuantity = String(quantity);
        button.classList.toggle('has-items-in-cart', visible);

        // Keep icon-only quick-add buttons accessible without changing their visual size.
        const productTitle = badge.dataset.productTitle || 'this product';
        if (button.classList.contains('quick-add__button--choose')) {
          button.setAttribute(
            'aria-label',
            visible ? `Choose options for ${productTitle}. ${quantity} in cart.` : `Choose options for ${productTitle}.`
          );
        } else {
          button.setAttribute(
            'aria-label',
            visible ? `Add another ${productTitle} to cart. ${quantity} in cart.` : `Add ${productTitle} to cart.`
          );
        }
      }
    });
  }

  function queueRender() {
    if (renderQueued) return;
    renderQueued = true;
    requestAnimationFrame(() => {
      renderQueued = false;
      renderBadges();
    });
  }

  async function refreshCartCounts() {
    const version = ++refreshVersion;
    try {
      const response = await fetch('/cart.js', {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return;

      const cart = await response.json();
      if (version !== refreshVersion) return;

      const nextQuantities = new Map();
      (Array.isArray(cart.items) ? cart.items : []).forEach((item) => {
        const productId = String(item.product_id || '');
        const quantity = Number(item.quantity) || 0;
        if (!productId || quantity <= 0) return;
        nextQuantities.set(productId, (nextQuantities.get(productId) || 0) + quantity);
      });

      productQuantities = nextQuantities;
      renderBadges();
    } catch (error) {
      console.warn('Unable to refresh product-card cart quantities.', error);
    }
  }

  document.addEventListener('cart:update', refreshCartCounts);

  const observer = new MutationObserver((records) => {
    if (records.some((record) => record.addedNodes.length > 0 || record.removedNodes.length > 0)) {
      queueRender();
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshCartCounts, { once: true });
  } else {
    refreshCartCounts();
  }

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') refreshCartCounts();
  });
})();
